
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"loading":"Aktualisiere ...","loadingLong":"Laden dauert an ...","outdatedData":"Die Sicht ist nicht aktuell.","button.cancel":"Abbrechen","button.update":"Aktualisieren"},"en":{"loading":"Loading ...","loadingLong":"Continue loading ...","outdatedData":"The view is outdated.","button.cancel":"Cancel","button.update":"Update"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();